export default __webpack_public_path__ + "static/media/logo_large_white.41ab7a3a.png";